import './scss/count-down.scss'
import type { BannerFixoProps } from "../../../banner-fixo.props"
import { dateDiffDays } from "@/utils/date-helpers"

interface CountDownProps {
    data: {
        banner: BannerFixoProps
        device: number
    }
    refresh?: boolean
}

export function CountDown({ data, refresh = false }: CountDownProps) {

    const isMobile = data.device === 2
    const bgCorFundo: { style: { background: string } } | object = data.banner.opcoes.corFundo ? { style: { background: '#'+ data.banner.opcoes.corFundo} } : {}
    const borderColor: { style: { borderColor: string } } | object = data.banner.opcoes.corFundo ? { style: { borderColor: '#'+data.banner.opcoes.corFundo} } : {}

    const classTimerMobile = isMobile ? 'timer-mobile' : ''
    const modeloTimer = data.banner.opcoes.modeloTimer || 'timer-1'
    const posicaoTimer = data.banner.opcoes.posicaoTimer || 'timer-center'
    const styleContadorBanner: typeof bgCorFundo = (['timer-1', 'timer-2'].includes(modeloTimer)) ? {...bgCorFundo} : {}
    const styleCountDown: { style: { color: string } } | object = data.banner.opcoes.corTexto ? { style: { color: '#'+data.banner.opcoes.corTexto } } : {}

    const styleDia: typeof bgCorFundo = isMobile ? {...bgCorFundo} : {}
    const styleItemCount: typeof bgCorFundo = modeloTimer === 'timer-3' ? {...bgCorFundo} : {}

    const bgCorFundoMobile = isMobile ? {...bgCorFundo} : {}

    const leftDays = dateDiffDays({ value: data.banner.data_fim ?? '' })

    return (
        <div className={`contador-banner flex align-center justify-center ${classTimerMobile} ${modeloTimer} ${posicaoTimer}`} {...styleContadorBanner}>
            <div className={`countdown tipo clearfix ${isMobile ? 'is-mobile' : ''}`}
                data-inicio={data.banner.data_inicio_formatada}
                data-fim={data.banner.data_fim_formatada}
                data-progress={modeloTimer === 'timer-2' ? '1' : '0'}
                data-diff-days='true'
                data-refresh={refresh}
                {...styleCountDown}
            >
                <div className="alinha-contador flex align-center justify-center">
                    {(leftDays > 0) && (
                        <>
                            <span className="ctn dia" {...styleDia}>
                                <div className="item-count">
                                    <div className="count" {...styleItemCount}>00</div>
                                    {modeloTimer === 'timer-4' && (
                                        <span className="separator" {...borderColor}></span>
                                    )}
                                    {modeloTimer !== 'timer-2' && (
                                        <div className="tipo-tempo">dias</div>
                                    )}
                                </div>
                            </span>

                            {(modeloTimer === 'timer-1' || modeloTimer === 'timer-2') && (
                                <div className="text">:</div>
                            )}
                        </>
                    )}

                    <div className="ctn hora" {...bgCorFundoMobile}>
                        <div className="item-count">
                            <div className="count" {...(modeloTimer === 'timer-3' && Object.values(bgCorFundo).length) ? {...bgCorFundo} : {}}>
                                00
                            </div>

                            {(modeloTimer === 'timer-4') && (
                                <span className="separator" {...(Object.values(borderColor).length) ? {...borderColor} : {}}></span>
                            )}

                            {(modeloTimer !== 'timer-2') && (
                                <div className="tipo-tempo">horas</div>
                            )}
                        </div>
                    </div>

                    {(modeloTimer === 'timer-1' || modeloTimer === 'timer-2') && (
                        <div className="text">:</div>
                    )}

                    <div className="ctn min" {...(isMobile) ? {...borderColor} : {}}>
                        <div className="item-count">
                            <div className="count" {...(modeloTimer === 'timer-3') ? {...bgCorFundo} : {}}>
                                00
                            </div>

                            {(modeloTimer === 'timer-4') && (
                                <span className="separator" {...borderColor}></span>
                            )}

                            {(modeloTimer !== 'timer-2') && (
                                <div className="tipo-tempo">
                                    {isMobile || modeloTimer === 'timer-3' ? 'min' : 'minutos'}
                                </div>
                            )}
                        </div>
                    </div>

                    {(modeloTimer === 'timer-1' || modeloTimer === 'timer-2') && (
                        <div className="text">:</div>
                    )}

                    <div className="ctn seg" {...(isMobile) ? {...bgCorFundo} : {}}>
                        <div className="item-count">
                            <div className="count" {...(modeloTimer === 'timer-3') ? {...bgCorFundo} : {}}>
                                00
                            </div>

                            {(modeloTimer === 'timer-4') && (
                                <span className="separator" {...borderColor}></span>
                            )}
                            
                            {(modeloTimer !== 'timer-2') && (
                                <div className="tipo-tempo">
                                    { isMobile || modeloTimer === 'timer-3' ? 'seg' : 'segundos'}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {(modeloTimer === 'timer-2')
                    ? (
                        <div className="barra-progresso">
                            <div className="progresso" style={{ width: '0' }}></div>
                        </div>
                    )
                    : null}
            </div>
        </div>
    )
}